import { zodResolver } from '@hookform/resolvers/zod';
import {
  agendaSlotTypeSchema,
  PRESENTIEL_SLOT_TYPE,
  periodsOfTheDay,
} from '@omecare/utils';
import { z } from 'zod';

export const addOfficeWorkScheduleSlotFormSchema = z.object({
  doctorAttendingId: z.string(),
  periodOfTheDay: z.enum(periodsOfTheDay),
  // Consultation mode: `mixed` = présentiel (default), `fullvisio` = remote video.
  slotType: agendaSlotTypeSchema.default(PRESENTIEL_SLOT_TYPE),
  specificDates: z.array(z.coerce.date()),
  forceWithoutAssistant: z.boolean().default(false),
});

export type AddOfficeWorkScheduleSlotFormValues = z.infer<
  typeof addOfficeWorkScheduleSlotFormSchema
>;

export const addOfficeWorkScheduleSlotFormResolver = zodResolver(
  addOfficeWorkScheduleSlotFormSchema,
);
